import type { TagIntent } from '@omnipresentgroup/design-system';
import { OnboardingStatusValues, SOWStatusEnum } from '@omnipresentgroup/types';

export const EMPLOYEE_STATUS_CONFIG: Record<
  string,
  { label: string; intent: TagIntent }
> = {
  [SOWStatusEnum.SOW_AWAITING_PROPOSAL]: {
    label: 'Awaiting order form',
    intent: 'info',
  },
  [SOWStatusEnum.SOW_AWAITING_ACCEPTANCE]: {
    label: 'Awaiting acceptance',
    intent: 'warning',
  },
  [SOWStatusEnum.SOW_ACCEPTED]: {
    label: 'Order form accepted',
    intent: 'success',
  },
  [OnboardingStatusValues.INPROGRESS]: {
    label: 'Onboarding in progress',
    intent: 'info',
  },
  [OnboardingStatusValues.ACTIVE]: {
    label: 'Active',
    intent: 'success',
  },
  [OnboardingStatusValues.INACTIVE]: {
    label: 'Inactive',
    intent: 'default',
  },
};
